export default function NavLinksText(context) {
    if (MNTK.deviceType === 'd' && MNTK.headerLinks) {
        const $links = context.querySelectorAll('[data-link]');
        for (let i = 0; i < $links.length; i++) {
            const attr = $links[i].getAttribute('data-link');
            const { html, url } = MNTK.headerLinks[attr];
            const div = document.createElement('div');
            div.classList.add('navigation__links--block--dropdown');
            div.innerHTML = `${html}<a href="${url}" target="_blank">Подробнее</a>`;
            $links[i].appendChild(div);
        }
    }
}
